module.exports = __webpack_public_path__ + "img/logo1.38e5d0cd.jpg";